module.exports = __webpack_public_path__ + "static/media/start-job-button.935c6a14.png";